<template>
  <div id="top-section" class="top-section" :style="{ height: computedHeight }">
    <h3>Welcome to AntTV – your ultimate app for short dramas!</h3>
    <div style="margin-top: 30px">
      <download-buttom />
    </div>
  </div>
</template>

<script>
import DownloadButtom from '@/components/downloadButtom.vue'
export default {
  name: 'TopSection',
  components: {
    DownloadButtom,
  },
  data() {
    return {
      baseHeight: 980,
      aspectRatio: 4.0 / 2.0,
      containerWidth: window.innerWidth,
    }
  },
  computed: {
    computedHeight() {
      return `${this.containerWidth / this.aspectRatio}px`
    },
    computedFontImg() {
      return `${this.containerWidth / this.aspectRatio / 4.5}px`
    },
  },
  mounted() {
    this.updateHeight()
    window.addEventListener('resize', this.updateHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight)
  },
  methods: {
    updateHeight() {
      this.containerWidth = this.$el ? this.$el.clientWidth : window.innerWidth
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes side-top-bottom {
  0% {
    transform: translateY(-1000px) scale(0.8);
  }
  50% {
    transform: translateY(0) scale(0.8);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}
.top-section {
  background: url('@/assets/image/img_banner.png') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h3 {
    font-weight: bold;
    font-size: 58px;
    color: #fff;
    letter-spacing: 2px;
    width: 60%;
    text-align: center;
    animation: side-top-bottom 1.5s ease-in-out forwards;
    @media screen and (max-width: 768px) {
      font-size: 29px;
    }
  }
  img {
    width: 250px;
    height: 80px;
    margin-top: 30px;
  }
}
</style>
